function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageupload/imageuploadediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { UpcastWriter } from 'ckeditor5/src/engine';
import { Notification } from 'ckeditor5/src/ui';
import { ClipboardPipeline } from 'ckeditor5/src/clipboard';
import { FileRepository } from 'ckeditor5/src/upload';
import { env } from 'ckeditor5/src/utils';
import ImageUtils from '../imageutils';
import UploadImageCommand from './uploadimagecommand';
import { fetchLocalImage, isLocalImage } from '../../src/imageupload/utils';
import { createImageTypeRegExp } from './utils';
/**
 * The editing part of the image upload feature. It registers the `'uploadImage'` command
 * and the `imageUpload` command as an aliased name.
 *
 * When an image is uploaded, it fires the {@link ~ImageUploadEditing#event:uploadComplete `uploadComplete` event}
 * that allows adding custom attributes to the {@link module:engine/model/element~Element image element}.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageUploadEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageUploadEditing, _Plugin);

  var _super = _createSuper(ImageUploadEditing);

  /**
   * @inheritDoc
   */
  function ImageUploadEditing(editor) {
    var _this;

    _classCallCheck(this, ImageUploadEditing);

    _this = _super.call(this, editor);
    editor.config.define('image', {
      upload: {
        types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
      }
    });
    /**
     * An internal mapping of {@link module:upload/filerepository~FileLoader#id file loader UIDs} and
     * model elements during the upload.
     *
     * Model element of the uploaded image can change, for instance, when {@link module:image/image/imagetypecommand~ImageTypeCommand}
     * is executed as a result of adding caption or changing image style. As a result, the upload logic must keep track of the model
     * element (reference) and resolve the upload for the correct model element (instead of the one that landed in the `$graveyard`
     * after image type changed).
     *
     * @private
     * @readonly
     * @member {Map.<String,module:engine/model/element~Element>}
     */

    _this._uploadImageElements = new Map();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageUploadEditing, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var doc = editor.model.document;
      var conversion = editor.conversion;
      var fileRepository = editor.plugins.get(FileRepository);
      var imageUtils = editor.plugins.get('ImageUtils');
      var imageTypes = createImageTypeRegExp(editor.config.get('image.upload.types'));
      var uploadImageCommand = new UploadImageCommand(editor); // Register `uploadImage` command and add `imageUpload` command as an alias for backward compatibility.

      editor.commands.add('uploadImage', uploadImageCommand);
      editor.commands.add('imageUpload', uploadImageCommand); // Register upcast converter for uploadId.

      conversion.for('upcast').attributeToAttribute({
        view: {
          name: 'img',
          key: 'uploadId'
        },
        model: 'uploadId'
      }); // Handle pasted images.
      // For every image file, a new file loader is created and a placeholder image is
      // inserted into the content. Then, those images are uploaded once they appear in the model
      // (see Document#change listener below).

      this.listenTo(editor.editing.view.document, 'clipboardInput', function (evt, data) {
        // Skip if non empty HTML data is included.
        // https://github.com/ckeditor/ckeditor5-upload/issues/68
        if (isHtmlIncluded(data.dataTransfer)) {
          return;
        }

        var images = Array.from(data.dataTransfer.files).filter(function (file) {
          // See https://github.com/ckeditor/ckeditor5-image/pull/254.
          if (!file) {
            return false;
          }

          return imageTypes.test(file.type);
        });

        if (!images.length) {
          return;
        }

        evt.stop();
        editor.model.change(function (writer) {
          // Set selection to paste target.
          if (data.targetRanges) {
            writer.setSelection(data.targetRanges.map(function (viewRange) {
              return editor.editing.mapper.toModelRange(viewRange);
            }));
          } // Upload images after the selection has changed in order to ensure the command's state is refreshed.


          editor.model.enqueueChange('default', function () {
            editor.execute('uploadImage', {
              file: images
            });
          });
        });
      }); // Handle HTML pasted with images with base64 or blob sources.
      // For every image file, a new file loader is created and a placeholder image is
      // inserted into the content. Then, those images are uploaded once they appear in the model
      // (see Document#change listener below).

      this.listenTo(editor.plugins.get('ClipboardPipeline'), 'inputTransformation', function (evt, data) {
        var fetchableImages = Array.from(editor.editing.view.createRangeIn(data.content)).filter(function (value) {
          return isLocalImage(imageUtils, value.item) && !value.item.getAttribute('uploadProcessed');
        }).map(function (value) {
          return {
            promise: fetchLocalImage(value.item),
            imageElement: value.item
          };
        });

        if (!fetchableImages.length) {
          return;
        }

        var writer = new UpcastWriter(editor.editing.view.document);

        var _iterator = _createForOfIteratorHelper(fetchableImages),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fetchableImage = _step.value;
            // Set attribute marking that the image was processed already.
            writer.setAttribute('uploadProcessed', true, fetchableImage.imageElement);
            var loader = fileRepository.createLoader(fetchableImage.promise);

            if (loader) {
              writer.setAttribute('src', '', fetchableImage.imageElement);
              writer.setAttribute('uploadId', loader.id, fetchableImage.imageElement);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }); // Prevents from the browser redirecting to the dropped image.

      editor.editing.view.document.on('dragover', function (evt, data) {
        data.preventDefault();
      }); // Upload placeholder images that appeared in the model.

      doc.on('change', function () {
        // Note: Reversing changes to start with insertions and only then handle removals. If it was the other way around,
        // loaders for **all** images that land in the $graveyard would abort while in fact only those that were **not** replaced
        // by other images should be aborted.
        var changes = doc.differ.getChanges({
          includeChangesInGraveyard: true
        }).reverse();
        var insertedImagesIds = new Set();

        var _iterator2 = _createForOfIteratorHelper(changes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var entry = _step2.value;

            if (entry.type == 'insert' && entry.name != '$text') {
              var item = entry.position.nodeAfter;
              var isInsertedInGraveyard = entry.position.root.rootName == '$graveyard';

              var _iterator3 = _createForOfIteratorHelper(getImagesFromChangeItem(editor, item)),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var imageElement = _step3.value;
                  // Check if the image element still has upload id.
                  var uploadId = imageElement.getAttribute('uploadId');

                  if (!uploadId) {
                    continue;
                  } // Check if the image is loaded on this client.


                  var loader = fileRepository.loaders.get(uploadId);

                  if (!loader) {
                    continue;
                  }

                  if (isInsertedInGraveyard) {
                    // If the image was inserted to the graveyard for good (**not** replaced by another image),
                    // only then abort the loading process.
                    if (!insertedImagesIds.has(uploadId)) {
                      loader.abort();
                    }
                  } else {
                    // Remember the upload id of the inserted image. If it acted as a replacement for another
                    // image (which landed in the $graveyard), the related loader will not be aborted because
                    // this is still the same image upload.
                    insertedImagesIds.add(uploadId); // Keep the mapping between the upload ID and the image model element so the upload
                    // can later resolve in the context of the correct model element. The model element could
                    // change for the same upload if one image was replaced by another (e.g. image type was changed),
                    // so this may also replace an existing mapping.

                    _this2._uploadImageElements.set(uploadId, imageElement);

                    if (loader.status == 'idle') {
                      // If the image was inserted into content and has not been loaded yet, start loading it.
                      _this2._readAndUpload(loader);
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }); // Set the default handler for feeding the image element with `src` and `srcset` attributes.

      this.on('uploadComplete', function (evt, _ref) {
        var imageElement = _ref.imageElement,
            data = _ref.data;
        var urls = data.urls ? data.urls : data;

        _this2.editor.model.change(function (writer) {
          writer.setAttribute('src', urls.default, imageElement);

          _this2._parseAndSetSrcsetAttributeOnImage(urls, imageElement, writer);
        });
      }, {
        priority: 'low'
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var schema = this.editor.model.schema; // Setup schema to allow uploadId and uploadStatus for images.
      // Wait for ImageBlockEditing or ImageInlineEditing to register their elements first,
      // that's why doing this in afterInit() instead of init().

      if (this.editor.plugins.has('ImageBlockEditing')) {
        schema.extend('imageBlock', {
          allowAttributes: ['uploadId', 'uploadStatus']
        });
      }

      if (this.editor.plugins.has('ImageInlineEditing')) {
        schema.extend('imageInline', {
          allowAttributes: ['uploadId', 'uploadStatus']
        });
      }
    }
    /**
     * Reads and uploads an image.
     *
     * The image is read from the disk and as a Base64-encoded string it is set temporarily to
     * `image[src]`. When the image is successfully uploaded, the temporary data is replaced with the target
     * image's URL (the URL to the uploaded image on the server).
     *
     * @protected
     * @param {module:upload/filerepository~FileLoader} loader
     * @returns {Promise}
     */

  }, {
    key: "_readAndUpload",
    value: function _readAndUpload(loader) {
      var _this3 = this;

      var editor = this.editor;
      var model = editor.model;
      var t = editor.locale.t;
      var fileRepository = editor.plugins.get(FileRepository);
      var notification = editor.plugins.get(Notification);
      var imageUtils = editor.plugins.get('ImageUtils');
      var imageUploadElements = this._uploadImageElements;
      model.enqueueChange('transparent', function (writer) {
        writer.setAttribute('uploadStatus', 'reading', imageUploadElements.get(loader.id));
      });
      return loader.read().then(function () {
        var promise = loader.upload();
        var imageElement = imageUploadElements.get(loader.id); // Force re–paint in Safari. Without it, the image will display with a wrong size.
        // https://github.com/ckeditor/ckeditor5/issues/1975

        /* istanbul ignore next */

        if (env.isSafari) {
          var viewFigure = editor.editing.mapper.toViewElement(imageElement);
          var viewImg = imageUtils.getViewImageFromWidget(viewFigure);
          editor.editing.view.once('render', function () {
            // Early returns just to be safe. There might be some code ran
            // in between the outer scope and this callback.
            if (!viewImg.parent) {
              return;
            }

            var domFigure = editor.editing.view.domConverter.mapViewToDom(viewImg.parent);

            if (!domFigure) {
              return;
            }

            var originalDisplay = domFigure.style.display;
            domFigure.style.display = 'none'; // Make sure this line will never be removed during minification for having "no effect".

            domFigure._ckHack = domFigure.offsetHeight;
            domFigure.style.display = originalDisplay;
          });
        }

        model.enqueueChange('transparent', function (writer) {
          writer.setAttribute('uploadStatus', 'uploading', imageElement);
        });
        return promise;
      }).then(function (data) {
        model.enqueueChange('transparent', function (writer) {
          var imageElement = imageUploadElements.get(loader.id);
          writer.setAttribute('uploadStatus', 'complete', imageElement);
          /**
           * An event fired when an image is uploaded. You can hook into this event to provide
           * custom attributes to the {@link module:engine/model/element~Element image element} based on the data from
           * the server.
           *
           * 		const imageUploadEditing = editor.plugins.get( 'ImageUploadEditing' );
           *
           * 		imageUploadEditing.on( 'uploadComplete', ( evt, { data, imageElement } ) => {
           * 			editor.model.change( writer => {
           * 				writer.setAttribute( 'someAttribute', 'foo', imageElement );
           * 			} );
           * 		} );
           *
           * You can also stop the default handler that sets the `src` and `srcset` attributes
           * if you want to provide custom values for these attributes.
           *
           * 		imageUploadEditing.on( 'uploadComplete', ( evt, { data, imageElement } ) => {
           * 			evt.stop();
           * 		} );
           *
           * **Note**: This event is fired by the {@link module:image/imageupload/imageuploadediting~ImageUploadEditing} plugin.
           *
           * @event uploadComplete
           * @param {Object} data The `uploadComplete` event data.
           * @param {Object} data.data The data coming from the upload adapter.
           * @param {module:engine/model/element~Element} data.imageElement The
           * model {@link module:engine/model/element~Element image element} that can be customized.
           */

          _this3.fire('uploadComplete', {
            data: data,
            imageElement: imageElement
          });
        });
        clean();
      }).catch(function (error) {
        // If status is not 'error' nor 'aborted' - throw error because it means that something else went wrong,
        // it might be generic error and it would be real pain to find what is going on.
        if (loader.status !== 'error' && loader.status !== 'aborted') {
          throw error;
        } // Might be 'aborted'.


        if (loader.status == 'error' && error) {
          notification.showWarning(error, {
            title: t('Upload failed'),
            namespace: 'upload'
          });
        } // Permanently remove image from insertion batch.


        model.enqueueChange('transparent', function (writer) {
          writer.remove(imageUploadElements.get(loader.id));
        });
        clean();
      });

      function clean() {
        model.enqueueChange('transparent', function (writer) {
          var imageElement = imageUploadElements.get(loader.id);
          writer.removeAttribute('uploadId', imageElement);
          writer.removeAttribute('uploadStatus', imageElement);
          imageUploadElements.delete(loader.id);
        });
        fileRepository.destroyLoader(loader);
      }
    }
    /**
     * Creates the `srcset` attribute based on a given file upload response and sets it as an attribute to a specific image element.
     *
     * @protected
     * @param {Object} data Data object from which `srcset` will be created.
     * @param {module:engine/model/element~Element} image The image element on which the `srcset` attribute will be set.
     * @param {module:engine/model/writer~Writer} writer
     */

  }, {
    key: "_parseAndSetSrcsetAttributeOnImage",
    value: function _parseAndSetSrcsetAttributeOnImage(data, image, writer) {
      // Srcset attribute for responsive images support.
      var maxWidth = 0;
      var srcsetAttribute = Object.keys(data) // Filter out keys that are not integers.
      .filter(function (key) {
        var width = parseInt(key, 10);

        if (!isNaN(width)) {
          maxWidth = Math.max(maxWidth, width);
          return true;
        }
      }) // Convert each key to srcset entry.
      .map(function (key) {
        return "".concat(data[key], " ").concat(key, "w");
      }) // Join all entries.
      .join(', ');

      if (srcsetAttribute != '') {
        writer.setAttribute('srcset', {
          data: srcsetAttribute,
          width: maxWidth
        }, image);
      }
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [FileRepository, Notification, ClipboardPipeline, ImageUtils];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageUploadEditing';
    }
  }]);

  return ImageUploadEditing;
}(Plugin); // Returns `true` if non-empty `text/html` is included in the data transfer.
//
// @param {module:clipboard/datatransfer~DataTransfer} dataTransfer
// @returns {Boolean}


export { ImageUploadEditing as default };
export function isHtmlIncluded(dataTransfer) {
  return Array.from(dataTransfer.types).includes('text/html') && dataTransfer.getData('text/html') !== '';
}

function getImagesFromChangeItem(editor, item) {
  var imageUtils = editor.plugins.get('ImageUtils');
  return Array.from(editor.model.createRangeOn(item)).filter(function (value) {
    return imageUtils.isImage(value.item);
  }).map(function (value) {
    return value.item;
  });
}